import { message, Spin } from 'antd';
import React, { useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { AddUserAuthSocial } from '../../../network/auth';
export default function SocialAuth() {
  const [searchParams, setSearchParams] = useSearchParams();
  let location = useLocation();
  console.log(location, 'location');
  useEffect(() => {
    const state = searchParams.get('state');
    const code = searchParams.get('code');
    const scope = searchParams.get('scope');
    const authuser = searchParams.get('authuser');
    const prompt = searchParams.get('prompt');
    // const body = {
    //   state,
    //   code,
    //   scope,
    //   authuser,
    //   prompt,
    // };
    // console.log(body, 'body');
    onAddUserAuthSocial(location?.search);
  }, []);

  const { mutate: onAddUserAuthSocial } = useMutation({
    mutationFn: (url: any) => AddUserAuthSocial(url),
    onSuccess: (res: any) => {
      if (res?.response?.status === 422 || res?.response?.status === 500) {
        message.error(res?.response?.data?.message);
      } else {
        setTimeout(() => {
          //   navigate(`/login`);
        }, 7000);
      }
    },
    onError: (error) => {
      message.error('حاول مرة اخرى');
    },
  });

  return (
    <div className="flex items-center justify-center min-h-[100vh]">
      <Spin indicator={<LoadingOutlined />} size="large" spinning />
    </div>
  );
}
